import { ScanResult } from '../types/index';

export const exportToJSON = (result: ScanResult): void => {
    const exportData = {
        metadata: {
            url: result.url,
            timestamp: result.timestamp,
            scanDuration: result.scanDuration,
            pageTitle: result.pageInfo.title
        },
        summary: {
            totalIssues: result.summary.totalIssues,
            criticalIssues: result.summary.criticalIssues,
            seriousIssues: result.summary.seriousIssues,
            moderateIssues: result.summary.moderateIssues,
            minorIssues: result.summary.minorIssues,
            wcagLevel: result.summary.wcagLevel,
            section508Compliant: result.summary.section508Compliant
        },
        issues: {
            violations: result.issues.axeIssues.map(issue => ({
                id: issue.id,
                impact: issue.impact,
                description: issue.description,
                help: issue.help,
                helpUrl: issue.helpUrl,
                wcagLevel: issue.wcagLevel,
                section508: issue.section508,
                affectedElements: issue.nodes.length,
                friendlyMessage: issue.friendlyMessage
            })),
            colorContrast: result.issues.colorContrastIssues,
            keyboard: result.issues.keyboardNavigationIssues,
            images: result.issues.imageAccessibilityIssues,
            forms: result.issues.formAccessibilityIssues,
            structural: result.issues.structuralIssues
        },
        pageInfo: result.pageInfo
    };

    const jsonString = JSON.stringify(exportData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `accessibility-scan-${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
